import { Grid } from '@constellation/core';
import styled from 'styled-components';

export const StyledGrid = styled(Grid)`
  min-height: 328px !important;
`;
